export default __webpack_public_path__ + "e18a91a0b3d91fcf473726134bffc052.png";